module.exports = __webpack_public_path__ + "static/img/scene-8.58ee6a1a.jpg";